import React from "react";
import { bool } from "prop-types";
import { twMerge } from "tailwind-merge";

import CalculatorIcon from "@components/shared/Icons/Calculator";
import Icon from "@components/shared/Icons/Icon";
import Typography from "@components/shared/Typography";

import { useTranslation } from "@lib/i18n";
import { useOpenFinanceWidget } from "@hooks/useOpenFinanceWidget";

const FinanceWidgetButton = ({ isBasketUi }) => {
  const openFinanceWidget = useOpenFinanceWidget();
  const { t } = useTranslation();

  return (
    <button
      className={twMerge(
        "flex justify-center items-center outline-none cursor-pointer lg:w-38",
        isBasketUi && "items-end h-10 lg:w-66"
      )}
      data-id="finance-icon-container"
      onClick={openFinanceWidget}
    >
      <Icon className="size-6 text-white" icon={<CalculatorIcon />} />
      <Typography
        className="
        block pl-2
        text-sm/tight text-white text-left uppercase no-underline font-semibold tracking-wide
        cursor-pointer whitespace-nowrap
        md:whitespace-normal md:block lg:pl-3
      "
      >
        {t("price.financeWidgetFinance")}
      </Typography>
    </button>
  );
};

FinanceWidgetButton.propTypes = {
  isBasketUi: bool,
};

export default FinanceWidgetButton;
